// src/components/lekhi/FlashcardView.js
import React, { useState } from 'react';
import './FlashcardView.css';

const FlashcardView = ({ flashcards, language, onComplete, onBack }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [hintShown, setHintShown] = useState(false);

  const labels = language === 'mr'
    ? {
        back: '← मागे',
        title: 'फ्लॅशकार्ड्स',
        showHint: 'संकेत पाहा',
        showAnswer: 'उत्तर पाहा',
        backToQuestion: 'पुन्हा प्रश्न पाहा',
        next: 'पुढे',
        remember: 'लक्षात ठेवा'
      }
    : {
        back: '← Back',
        title: 'Flashcards',
        showHint: 'Show hint',
        showAnswer: 'Show answer',
        backToQuestion: 'Back to question',
        next: 'Continue',
        remember: 'Remember'
      };

  if (!flashcards || flashcards.length === 0) {
    return (
      <div className="lk-fc-container">
        <div className="lk-fc-header">
          <button className="back-btn" onClick={onBack}>{labels.back}</button>
          <div className="lk-fc-title">{labels.title}</div>
          <div style={{ width: 60 }} />
        </div>
        <div style={{ padding: 40, textAlign: 'center', color: '#6c757d' }}>
          No flashcards
        </div>
      </div>
    );
  }

  const card = flashcards[currentIndex];
  const isLastCard = currentIndex === flashcards.length - 1;

  const handleShowHint = () => {
    setHintShown(true);
  };

  const handleShowAnswer = () => {
    setFlipped(true);
  };

  const handleBackToQuestion = () => {
    setFlipped(false);
  };

  const handleNext = () => {
    if (isLastCard) {
      onComplete();
    } else {
      setCurrentIndex(currentIndex + 1);
      setFlipped(false);
      setHintShown(false);
    }
  };

  return (
    <div className="lk-fc-container">
      <div className="lk-fc-header">
        <button className="back-btn" onClick={onBack}>{labels.back}</button>
        <div className="lk-fc-title">{labels.title}</div>
        <div style={{ width: 60 }} />
      </div>

      <div className="lk-fc-progress">
        <span className="lk-fc-progress-text">{currentIndex + 1} / {flashcards.length}</span>
        <div className="lk-fc-dots">
          {flashcards.map((_, i) => (
            <span key={i} className={`lk-fc-dot ${i === currentIndex ? 'active' : ''} ${i < currentIndex ? 'done' : ''}`} />
          ))}
        </div>
      </div>

      <div className="lk-fc-body">
        <div className={`lk-fc-card-wrap ${flipped ? 'flipped' : ''}`}>
          <div className="lk-fc-card lk-fc-card-front">
            <div className="lk-fc-question">{card.front}</div>
            {hintShown && card.hint && (
              <div className="lk-fc-hint">
                <span className="lk-fc-hint-label">संकेत:</span> {card.hint}
              </div>
            )}
          </div>
          <div className="lk-fc-card lk-fc-card-back">
            <div className="lk-fc-answer">{card.back}</div>
            {card.example && (
              <div className="lk-fc-remember">
                <div className="lk-fc-remember-label">💡 {labels.remember}</div>
                <div className="lk-fc-remember-text">{card.example}</div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="lk-fc-footer">
        {!flipped ? (
          <>
            {card.hint && (
              <button
                className={`lk-fc-secondary-btn ${hintShown ? 'disabled' : ''}`}
                onClick={handleShowHint}
                disabled={hintShown}
              >
                {labels.showHint}
              </button>
            )}
            <button className="lk-fc-primary-btn" onClick={handleShowAnswer}>
              {labels.showAnswer}
            </button>
          </>
        ) : (
          <>
            <button className="lk-fc-secondary-btn" onClick={handleBackToQuestion}>
              {labels.backToQuestion}
            </button>
            <button className="lk-fc-primary-btn" onClick={handleNext}>
              {labels.next}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default FlashcardView;